<template>
  <div id="download">
    <div class="bac">
      <div class="content">
        <div class="top">
          <div class="item1">
            <div class="qrCode">
              <div class="qr">
                <div id="qrcode3" ref="qrcode3" class="qrimg"></div>
              </div>
            </div>
            <div>Android版下载</div>
          </div>
          <div class="item2">
            <div class="qrCode">
              <div class="qr">
                <div id="qrcode5" ref="qrcode5" class="qrimg"></div>
              </div>
            </div>
            <div>IOS版下载</div>
          </div>
        </div>
        <div class="bottom">
          手机便捷下注，工作生活两不误；随时随地，畅玩游戏就这么简单
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      customerList: [],
      openUrl: "",
      sessData: "",
      isCollapse: true,
    };
  },
  mounted() {
    this.codeList();
  },
  methods: {
    codeList() {
      let that = this;
      // that.sessData = JSON.parse(sessionStorage.getItem('inviteCode'))
      // var qrCodeAddress = ''
      // if (that.sessData) {
      //     qrCodeAddress = `${that.$config.dowUrl}${window.clientCode}${window.theme}/${that.sessData}`
      // } else {
      //     qrCodeAddress = `${that.$config.dowUrl}${window.clientCode}${window.theme}`;
      // }
      let iosurl = location.origin + "/downloadUrl?";
      let andurl = location.origin + "/downloadUrl?";
      iosurl += "code=" + window.clientCode;
      andurl += "code=" + window.clientCode;
      if (that.$config.iosDownloadUrl) {
        iosurl += "&ios=" + encodeURIComponent(that.$config.iosDownloadUrl);
      }
      if (that.$config.androiDownloadUrl) {
        andurl +=
          "&android=" + encodeURIComponent(that.$config.androiDownloadUrl);
      }
      if (that.$config.pcDownloadUrl) {
        iosurl += "&pc=" + encodeURIComponent(that.$config.pcDownloadUrl);
        andurl += "&pc=" + encodeURIComponent(that.$config.pcDownloadUrl);
      }
      that.qrcode("qrcode3", andurl);
      that.qrcode("qrcode5", iosurl);
    },
    qrcode(qrcodeId, qrcode) {
      new QRCode(qrcodeId, {
        width: 128, // 设置宽度，单位像素
        height: 128, // 设置高度，单位像素
        text: qrcode, // 设置二维码内容或跳转地址
      });
    },
  },
};
</script>

<style scoped>
.qrCode {
  display: block;
  top: 0;
  right: 70px;
  cursor: default;
  background-color: #fff;
  margin-bottom: 5px;
}
.qr {
  padding: 10px;
  background-color: #ffffff;
  color: #000;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.qrText {
  margin-top: 10px;
  font-size: 13px;
}
.qrimg {
  width: 100px;
  height: 100px;
}

.bac {
  background: url("../../static/img/b.png") center top no-repeat;
  margin: 0 auto;
  width: 1200px;
}
.content {
  margin-left: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.top {
  margin-top: 320px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.item1 {
  position: relative;
  background-color: #3fb036;
  width: 130px;
  height: 151px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.img {
  width: 120px;
  height: 120px;
  margin-top: 10px;
  margin-left: 5px;
}
.item2 {
  position: relative;
  align-items: center;
  color: #ffffff;
  width: 130px;
  height: 151px;
  background-color: #0087ff;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.bottom {
  color: #ba9a68;
  font-size: 12px;
  margin-top: 20px;
  padding-bottom: 150px;
}
</style>
